import { apiClient } from './api'

export interface Notification {
  id: number
  type: string
  title: string
  message: string
  read: boolean
  link?: string
  channel: string
  digest_included: boolean
  created_at: string
}

export interface NotificationPreference {
  event_type: string
  in_app_enabled: boolean
  email_enabled: boolean
  digest_enabled: boolean
}

export const notificationsService = {
  list: async (unreadOnly = false, limit = 50): Promise<Notification[]> => {
    const { data } = await apiClient.get('/api/v1/notifications', {
      params: { unread_only: unreadOnly, limit },
    })
    return data
  },

  unreadCount: async (): Promise<number> => {
    const { data } = await apiClient.get('/api/v1/notifications/unread-count')
    return data.count
  },

  markRead: async (ids?: number[]): Promise<void> => {
    await apiClient.post('/api/v1/notifications/mark-read', { notification_ids: ids ?? null })
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/notifications/${id}`)
  },

  getPreferences: async (): Promise<NotificationPreference[]> => {
    const { data } = await apiClient.get('/api/v1/notifications/preferences')
    return data
  },

  updatePreference: async (
    eventType: string,
    updates: Partial<Omit<NotificationPreference, 'event_type'>>
  ): Promise<NotificationPreference> => {
    const { data } = await apiClient.put(`/api/v1/notifications/preferences/${eventType}`, updates)
    return data
  },
}
